import React, { useState } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { connect } from 'react-redux';

import { addSubscriptionEmail } from "../../services/backendCalls";
import {fetcSubscriptionRemark} from "../../services/actions";
import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings.js";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import EmailIllustrationSrc from "images/images/gettyimages-1266986195-612x612.jpg";

const Container = tw.div`relative`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-20 md:py-24`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(Column)`md:w-5/12 flex-shrink-0 h-80 md:h-auto`;
const TextColumn = styled(Column)(props => [
  tw`md:w-7/12 mt-16 md:mt-0`,
  props.textOnLeft ? tw`md:mr-12 lg:mr-16 md:order-first` : tw`md:ml-12 lg:ml-16 md:order-last`
]);

const Image = styled.div(props => [
  `background-image: url("${props.imageSrc}");`,
  tw`rounded bg-contain bg-no-repeat bg-center h-full`,
]);
const TextContent = tw.div`lg:py-8 text-center md:text-left`;

const Subheading = tw(SubheadingBase)`text-center md:text-left`;
const Heading = tw(SectionHeading)`mt-4 font-black text-left text-3xl sm:text-4xl lg:text-5xl text-center md:text-left leading-tight`;
const Description = tw.p`mt-4 text-center md:text-left text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100`

const Form = tw.form`mt-8 md:mt-10 text-sm flex flex-col lg:flex-row`
const Input = tw.input`border-2 px-5 py-3 rounded focus:outline-none font-medium transition duration-300 hocus:border-primary-500`

const SubmitButton = tw(PrimaryButtonBase)`inline-block lg:ml-6 mt-6 lg:mt-0`

const SComponent = (props) => {
  
  // The textOnLeft boolean prop can be used to display either the text on left or right side of the image.
  const subheading = props.SubscribeData.subheading;
  const heading = props.SubscribeData.heading;
  const description = props.SubscribeData.description;
  const submitButtonText = props.SubscribeData.submitButtonText;
  //const formAction = props.SubscribeData.formAction;
  const formMethod = props.SubscribeData.formMethod;
  const textOnLeft = props.SubscribeData.textOnLeft;
  const remark = props.SubscribeData.remark;
  
  
  const [ email, setEmail ] = useState("");
  const [ isSubmitting, setIsSubmitting ] = useState(false);

  return (
    <Container>
      <TwoColumn>
        <ImageColumn>
          <Image imageSrc={EmailIllustrationSrc} />
        </ImageColumn>
        <TextColumn textOnLeft={textOnLeft}>
          <TextContent>{remark && <Description>{remark}</Description>}
            {!remark && <Subheading>{subheading}</Subheading>}
            {!remark && <Heading>{heading}</Heading>}
            {!remark && <Description>{description}</Description>}
            {!remark && <Form onSubmit={async (e) => {
              e.preventDefault();
              if (!email.trim()) return;
              setIsSubmitting(true);
              try {
                await props.addSubscriptionEmail(e, email);
                setEmail("");
              } finally {
                setIsSubmitting(false);
              }
            }} method={formMethod}>
              <Input type="email" name="email" placeholder="Your Email Address" value={email} onChange={(e) => setEmail(e.target.value)} />
              <SubmitButton type="submit" disabled={isSubmitting}>{isSubmitting ? 'Submitting...' : submitButtonText}</SubmitButton>
            </Form>}
          </TextContent>
        </TextColumn>
      </TwoColumn>
    </Container>
  );
};


const Subscribe = connect((state) => ({
  SubscribeData: state.SubscribeData
}), (dispatch) => ({
  addSubscriptionEmail: async (e, email) => {
    e.preventDefault(); 
    await addSubscriptionEmail(email);
    dispatch(fetcSubscriptionRemark(email));
  }
}))(SComponent);

export default Subscribe;